import * as React from 'react';
import { Form } from 'react-bootstrap';
import { ErrorMessage } from 'formik';
import {
  createCtcCredential,
  updateCtcCredential,
  getCtcCredential,
  getCtcCredentialById,
} from '../../../redux/actions/CtcCredentials.action';

const CTC_ID_CACHE_PREFIX = 'ctcCredentialId:';
const cacheCredentialId = (adminId, credentialId) => {
  if (!adminId || !credentialId) return;
  try {
    localStorage.setItem(`${CTC_ID_CACHE_PREFIX}${adminId}`, credentialId);
  } catch (e) {}
};
const getCachedCredentialId = (adminId) => {
  if (!adminId) return null;
  try {
    return localStorage.getItem(`${CTC_ID_CACHE_PREFIX}${adminId}`);
  } catch (e) {
    return null;
  }
};

// Fixed default values — same for every admin, as shown in the CTC Credentials
// reference screenshot. Only CTC Number (CLINumber) is entered by the user.
const CTC_DEFAULT_VALUES = {
  CTC_USERNAME: 'Smartx@123',
  CTC_PASSWORD: 'Smartx@123',
  CTC_BASE_URL: 'https://cts.myvi.in:8443/Cpaas/api/v1',
  CTC_RECORDING_FLAG: 1,
  CTC_DTMF_FLAG: 0,
  CTC_PINGBACK_URL: 'https://educacrm.in/api/click-to-call/pingback',
  CTC_PINGBACK_SECRET: '123mnbvcxz',
};

export const getCtcDefaultValues = () => ({ ...CTC_DEFAULT_VALUES });

export const fetchCtcCredential = async (dispatch, adminId) => {
  if (!adminId) return null;
  const res = await dispatch(getCtcCredentialById(adminId));
  const credential = res?.data?.data;
  if (!credential || credential.status === false || !credential._id) {
    return null;
  }
  cacheCredentialId(adminId, credential._id);
  return {
    CLINumber: credential.CLINumber || '',
  };
};

export const saveCtcCredential = async (dispatch, adminId, values) => {
  if (!values?.isIvr || !adminId) return;
  const ctcData = {
    ...CTC_DEFAULT_VALUES,
    CLINumber: values.CLINumber,
  };
  const credentialId = getCachedCredentialId(adminId);
  let res;
  if (credentialId) {
    res = await dispatch(updateCtcCredential(credentialId, ctcData));
  } else {
    res = await dispatch(createCtcCredential(adminId, ctcData));
  }
  if (res?.data?.data?._id) {
    cacheCredentialId(adminId, res.data.data._id);
  }
  return res;
};

const CtcCredentialsForm = ({ values, setFieldValue }) => {
  return (
    <div className="col-12 mb-3">
      <div className="border rounded p-3" style={{ background: '#f8f9fb' }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">CTC Credentials</h5>
        </div>
        <Form.Group className="mb-0">
          <Form.Label>
            CTC Number: <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={values.CLINumber || ''}
            onChange={(e) => setFieldValue('CLINumber', e.target.value)}
            placeholder="Enter CTC Number"
            className="shadow-none focus:!border-theme-dark"
          />
          <ErrorMessage
            name="CLINumber"
            component="div"
            className="text-danger"
          />
        </Form.Group>
      </div>
    </div>
  );
};

export default CtcCredentialsForm;
